import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiService } from './api.service';
import { ProjectV2ServiceService } from './project-v2-service.service';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { EmitterService } from './emitter.service';
import { fetchAllPages } from '../utils/paged-fetch';
import { CampaignSimulatorParams, CampaignSimulatorResponse, DriveCampaign, TimelineDisplayMode } from '../interfaces';

export interface headerData {
  url: string;
  userName: string;
  title: string;
  isbackGround: boolean;
  isTaskProject: boolean;
  isDashboard: boolean;
  isRecap: boolean;
  isGeneral: boolean;
  hideGeneralComponent: boolean;
  urlInside: string;
  isWorkspace: boolean;
  headerTitle?: string;
}
export interface componentData {
  componentName: string;
  bannerUrl: string;
}

export const MilestoneSelected = 'milestone.selected';

@Injectable({
  providedIn: 'root',
})
export class TimelineService {
  ngUnsubscribe = new Subject();
  driveCampaignData: any;
  driveCampaignId: string;
  campaignName: string = '';
  workspaceId: string = '';
  private _workspaceName: string = '';
  workspaceNameSubject = new BehaviorSubject<string>('');
  workspaceName$: Observable<string> = this.workspaceNameSubject.asObservable();

  get workspaceName(): string {
    return this._workspaceName;
  }

  set workspaceName(value: string) {
    this._workspaceName = value;
    if (this.workspaceNameSubject.getValue() !== value) {
      this.workspaceNameSubject.next(value);
    }
  }
  images = {
    analytics: '../../../assets/img/project-v2/analytics.png',
    campaignDriveDashboard: '../../../assets/img/project-v2/new-project.png',
    dashboard_hr: '../../../assets/img/project-v2/workspace-img.png',
    dashboard_ysl: '../../../assets/img/project-v2/ysl-dashboard.png',
    timeline: '../../../assets/img/project-v2/timeline-header.png',
    timeline_hr: '../../../assets/img/project-v2/workspace-img.png',
    timeline_ysl: '../../../assets/img/project-v2/ysl-dashboard.png',
    ysl: '../../../assets/img/project-v2/ysl-dashboard.png',
    taskproject_hr: '../../../assets/img/project-v2/task-project-header.png',
    taskproject_ysl: '../../../assets/img/project-v2/new-project.png',
    scenario2: '../../../assets/img/project-v2/scenario2Dashboard.png',
    scenario4ysl: '../../../assets/img/project-v2/scenario4yslheader.png',
    headerImage: '../../../assets/img/project-v2/workspace-img.png',
    yslBrandLogo: '../../../assets/img/project-v2/ysl-brand-logo.png',
    hrBrandLogo: '../../../assets/img/project-v2/hr-brand-logo.png',
  };
  fullName: string;
  jobTitle: string;
  randomImages = {
    campaign: [
      { src: '../../../assets/img/random-img/campaign1.png', alt: 'Random Campaign Image 1' },
      { src: '../../../assets/img/random-img/campaign2.png', alt: 'Random Campaign Image 2' },
      { src: '../../../assets/img/random-img/campaign3.png', alt: 'Random Campaign Image 3' },
      { src: '../../../assets/img/random-img/campaign4.png', alt: 'Random Campaign Image 4' },
      { src: '../../../assets/img/random-img/campaign5.png', alt: 'Random Campaign Image 5' },
      { src: '../../../assets/img/random-img/campaign6.png', alt: 'Random Campaign Image 6' },
      { src: '../../../assets/img/random-img/campaign7.png', alt: 'Random Campaign Image 7' },
      { src: '../../../assets/img/random-img/campaign8.png', alt: 'Random Campaign Image 8' },
      { src: '../../../assets/img/random-img/campaign9.png', alt: 'Random Campaign Image 9' },
      { src: '../../../assets/img/random-img/campaign10.png', alt: 'Random Campaign Image 10' },
      { src: '../../../assets/img/random-img/campaign11.png', alt: 'Random Campaign Image 11' },
      { src: '../../../assets/img/random-img/campaign12.png', alt: 'Random Campaign Image 12' },
      { src: '../../../assets/img/random-img/campaign13.png', alt: 'Random Campaign Image 13' },
      { src: '../../../assets/img/random-img/campaign14.png', alt: 'Random Campaign Image 14' },
      { src: '../../../assets/img/random-img/campaign15.png', alt: 'Random Campaign Image 15' },
      { src: '../../../assets/img/random-img/campaign16.png', alt: 'Random Campaign Image 16' },
      { src: '../../../assets/img/random-img/campaign17.png', alt: 'Random Campaign Image 17' },
      { src: '../../../assets/img/random-img/campaign18.png', alt: 'Random Campaign Image 18' },
      { src: '../../../assets/img/random-img/campaign19.png', alt: 'Random Campaign Image 19' },
      { src: '../../../assets/img/random-img/campaign20.png', alt: 'Random Campaign Image 20' },
    ],
    project: [
      { src: '../../../assets/img/random-img/project1.png', alt: 'Random project Image 1' },
      { src: '../../../assets/img/random-img/project2.png', alt: 'Random project Image 2' },
      { src: '../../../assets/img/random-img/project3.png', alt: 'Random project Image 3' },
      { src: '../../../assets/img/random-img/project4.png', alt: 'Random project Image 4' },
      { src: '../../../assets/img/random-img/project5.png', alt: 'Random project Image 5' },
      { src: '../../../assets/img/random-img/project6.png', alt: 'Random project Image 6' },
      { src: '../../../assets/img/random-img/project7.png', alt: 'Random project Image 7' },
      { src: '../../../assets/img/random-img/project8.png', alt: 'Random project Image 8' },
      { src: '../../../assets/img/random-img/project9.png', alt: 'Random project Image 9' },
      { src: '../../../assets/img/random-img/project10.png', alt: 'Random project Image 10' },
      { src: '../../../assets/img/random-img/project11.png', alt: 'Random project Image 11' },
      { src: '../../../assets/img/random-img/project12.png', alt: 'Random project Image 12' },
      { src: '../../../assets/img/random-img/project13.png', alt: 'Random project Image 13' },
      { src: '../../../assets/img/random-img/project14.png', alt: 'Random project Image 14' },
      { src: '../../../assets/img/random-img/project15.png', alt: 'Random project Image 15' },
      { src: '../../../assets/img/random-img/project16.png', alt: 'Random project Image 16' },
      { src: '../../../assets/img/random-img/project17.png', alt: 'Random project Image 17' },
      { src: '../../../assets/img/random-img/project18.png', alt: 'Random project Image 18' },
      { src: '../../../assets/img/random-img/project19.png', alt: 'Random project Image 19' },
      { src: '../../../assets/img/random-img/project20.png', alt: 'Random project Image 20' },
    ],
  };
  imageEventEmitter: EventEmitter<headerData> = new EventEmitter<headerData>();
  workspaceBannerEmitter: EventEmitter<string> = new EventEmitter<string>();
  searchEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  workspaceDashboardEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  resetTabsEmmiter: EventEmitter<boolean> = new EventEmitter<boolean>();

  // set and get selected milestone
  milestone = new BehaviorSubject<any>({});
  selectedMilestone$: Observable<any> = this.milestone.asObservable();
  selectedCampaign$: Observable<any> = this.milestone.asObservable();

  // set header image
  componentName = new BehaviorSubject<componentData>({
    componentName: '',
    bannerUrl: '',
  });

  selectedComponent$: Observable<componentData> = this.componentName.asObservable();

  setworksapceId = new BehaviorSubject<string>('');
  getWorkspaceId$: Observable<string> = this.setworksapceId.asObservable();

  // show and hide tabs of drive campaign
  isDriveNav: EventEmitter<boolean> = new EventEmitter<boolean>();

  // set timeline for update milestone status
  setTimeline = new BehaviorSubject<any>({});
  getTimelineData: Observable<any> = this.setTimeline.asObservable();

  // get current workspace data from sidebar nav
  selectedWorkspace: EventEmitter<any> = new EventEmitter<any>();

  // task description
  taskDescription = new BehaviorSubject<any[]>([]);

  // below emmiters are for views on drive campaign and campaigns
  isAll: EventEmitter<boolean> = new EventEmitter<boolean>();
  isArchived: EventEmitter<boolean> = new EventEmitter<boolean>();
  isFavorites: EventEmitter<boolean> = new EventEmitter<boolean>();

  // show and hide cross button on milestone timeline block
  showCrossBtn: EventEmitter<boolean> = new EventEmitter<boolean>();

  activeCampaign$ = new Subject<DriveCampaign>();
  timelineDisplay$ = new BehaviorSubject<TimelineDisplayMode>(TimelineDisplayMode.Horizontal);

  // dropdown event
  private readonly dropdownState = new Subject<void>();
  dropdownState$ = this.dropdownState.asObservable();
  // Emit events when needed
  emitIsAll(value: boolean): void {
    this.isAll.emit(value);
  }

  emitIsArchived(value: boolean): void {
    this.isArchived.emit(value);
  }

  emitIsFavorites(value: boolean): void {
    this.isFavorites.emit(value);
  }

  lastSelectedDriveCampaign: any;
  lastSelectedMilestone: any;
  lastSelectedCampaign: any;

  // for calendar view milestone
  calendarViewmilestone: any;

  // Function to update the milestone value
  public updateMilestone(newMilestone: any) {
    this.milestone.next(newMilestone);
    if (!newMilestone) {
      this.router.navigate(['workspaces']);
    }
  }

  constructor(
    private readonly apiService: ApiService,
    private readonly projectV2Service: ProjectV2ServiceService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    try {
      let userData: any = localStorage.getItem('auth_user');
      userData = JSON.parse(userData);
      this.fullName = userData.fullName;
      this.jobTitle = userData.jobTitle;
    } catch {}
  }

  // create random color based on name
  // start
  stringToRGB(name?: string): [number, number, number] {
    let hash = 0;
    if (name) {
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const r = (hash & 0xff0000) >> 16;
      const g = (hash & 0x00ff00) >> 8;
      const b = hash & 0x0000ff;
      return [r, g, b];
    }
  }

  RGBToHex(rgb: [number, number, number]): string {
    if (rgb) {
      return `#${rgb.map((c) => c.toString(16).padStart(2, '0')).join('')}`;
    }
  }

  getColorFromName(name: string): string {
    if (name) {
      const rgb = this.stringToRGB(name);
      const hexColor = this.RGBToHex(rgb);
      return hexColor;
    } else {
      return 'rgba(0,0,0,0.03)';
    }
  }
  // end

  getDriveCampaign(workspaceId: string, driveCampaignId: string): Observable<any> {
    return this.apiService.httpGet(
      `/api/campaigns/${workspaceId}/${driveCampaignId}`,
      false,
      {},
      { redirectOnForbidden: true }
    );
  }

  async getTimeLine(selectedworkspaceId: string, drivCampaignId: string, assetListProject = false): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.projectV2Service
        .getSingleDriveCampaign(selectedworkspaceId, drivCampaignId, assetListProject)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (result) => {
            this.driveCampaignId = result.id;
            this.workspaceId = result.workspaceId;
            this.driveCampaignData = result;
            EmitterService.get('CAMPAIGN_DATA_UPDATED').emit(this.driveCampaignData);
            resolve(result);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getTimelineSimulator(params: CampaignSimulatorParams): Observable<CampaignSimulatorResponse> {
    return this.apiService.httpPost(`/api/campaigns/simulator`, params);
  }

  // get milestone projects
  getMilestoneProjects(campaignId: string, workspaceId: string, milestoneId: string) {
    return fetchAllPages((page: number) =>
      this.apiService.httpGet(
        `/api/projects/users/${this.authService.getAuthUserName()}?milestoneId=${milestoneId}&page=${page}`,
        false,
        {},
        {
          redirectOnForbidden: true,
        }
      )
    );
  }

  // setting top nav bar image and other required detail
  getComponentDetail() {
    this.selectedComponent$.subscribe((data: componentData) => {
      if (data) {
        const header: headerData = {
          headerTitle: '',
          url: '',
          urlInside: '',
          userName: '',
          title: '',
          isWorkspace: false,
          isbackGround: false,
          isTaskProject: false,
          isDashboard: false,
          isGeneral: false,
          isRecap: false,
          hideGeneralComponent: false,
        };
        const myBrand = this.authService.getMyBrand();
        const path = myBrand?.name == 'Yves Saint Laurent' ? 'ysl' : 'hr';
        switch (data.componentName) {
          // Update the value based on the case match
          case 'workspaceComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            // header.url = data.bannerUrl ? data.bannerUrl : this.images[`dashboard_${path}`];
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            header.headerTitle = 'Workspaces';
            break;
          case 'taskComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            // header.url = data.bannerUrl ? data.bannerUrl : this.images[`dashboard_${path}`];
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isTaskProject = true;
            header.isDashboard = true;
            break;
          case 'campaignDriveComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            header.headerTitle = 'Drive Campaigns';
            break;
          case 'milestoneComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            break;
          case 'timelineSettingComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            header.hideGeneralComponent = true;
            break;
          case 'generalComponent':
            header.url = data.bannerUrl ? data.bannerUrl : this.images.timeline;
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = false;
            header.isGeneral = true;
            break;
          case 'recapeComponent':
            header.url = data.bannerUrl ? data.bannerUrl : this.images.timeline;
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = false;
            header.isRecap = true;
            break;
          case 'recapeComponentInside':
            header.url = data.bannerUrl ? data.bannerUrl : this.images.timeline;
            header.urlInside = data.bannerUrl ? data.bannerUrl : this.images[`timeline_${path}`];
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = false;
            header.isRecap = true;
            break;
          case 'analyticsDashboardComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            break;
          case 'camapignDriveNavComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = false;
            break;
          case 'campaignsComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            header.headerTitle = 'Campaigns';
            break;
          case 'projectsComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            header.headerTitle = 'Projects';
            break;
          case 'sharedComponent':
            header.url = data.bannerUrl ? data.bannerUrl : '';
            header.userName = this.fullName;
            header.title = this.jobTitle;
            header.isDashboard = true;
            header.headerTitle = 'Shared';
            break;
          default:
            break;
        }
        // Emit the updated value through the imageEventEmitter
        this.imageEventEmitter.emit(header);
      }
    });
  }

  //set brand logo
  brandLogo() {
    let brandimage;
    const brandName = this.authService.getMyBrand().name;
    switch (brandName) {
      case 'Yves Saint Laurent':
        return (brandimage = this.images.yslBrandLogo);
      case 'Helena Rubinstein':
        return (brandimage = this.images.hrBrandLogo);
      default:
        break;
    }
  }

  notifyDropdownOpened() {
    this.dropdownState.next();
  }
}
